export default [

     {
          path: '/kriunit',
          name: 'Kriunit',
          component: () => import("@/views/Page/Kriunit/Kriunit.vue"),
           meta: {
               title: 'Kri Unit',
          },
     }
];